
import React, {useState} from "react";
import {MY_APARTMENTS_TABS_MODEL} from "../Model/Model";
import CustomTabContainer from "../../../components/CustomTabContainer";
import CustomTab from "../../../components/CustomTab";
import MyHouseholdMembersCards from "./HouseholdMembers/MyHouseholdMembersCards";
import MyApartmentInvitationsTable from "./Invitations/MyApartmentInvitationsTable";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {PersonPlusIcon, PlusIconsOptions} from "../../../components/buttons/IconButtons";
import CreateHouseholdMemberModal from "../Modal/CreateHouseholdMemberModal";
import InviteExternalUserModal from "../Modal/InviteExternalUserModal";
/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
const MyApartmentDetailsMainTabs = ({
    t,
    buildingDetail,
    containerHeight
}) => {
    const [selectedTab, setSelectedTab] = useState(MY_APARTMENTS_TABS_MODEL.HOUSEHOLD_MEMBERS.key);
    const [createMemberModal, setCreateMemberModal] = useState(false);
    // Raised every time a modal of the tab saves so the list rendered is reloaded
    const [modified, setModified] = useState(false);
    // Invite external user modal, the first step of the visitor invitation, it is
    // opened from the invite button of the invitations tab
    const [inviteExternalUserModal, setInviteExternalUserModal] = useState(false);
    const isHouseholdMembers = selectedTab === MY_APARTMENTS_TABS_MODEL.HOUSEHOLD_MEMBERS.key;

    return (
        <div className="border-full-shades-300 border-radius-8px p-16px overflow-hidden d-flex flex-column minh-645px" style={{height:containerHeight }}>
            <CustomTabContainer
                activeTab={selectedTab}
                setActiveTab={(e) => {
                    setSelectedTab(e);
                }}
                className="border-0 px-0"
                paddingClass=''
                classNameActions="flex-shrink-0 "
                buttonAction={isHouseholdMembers ?
                    <ButtonAction
                        id='btn_bdmt_add_member'
                        name='add_member'
                        className='btn-icon-add'
                        Icon={PlusIconsOptions}
                        splitName={false}
                        disabled={false}
                        onClick={() => setCreateMemberModal(true)}
                    />
                    :
                    <ButtonAction
                        id='btn_bdmt_invite'
                        name='invite'
                        className='btn-icon-add'
                        Icon={PersonPlusIcon}
                        splitName={false}
                        disabled={false}
                        onClick={() => setInviteExternalUserModal(true)}
                    />
                }
            >
                {Object.values(MY_APARTMENTS_TABS_MODEL).map((item) => (
                    <CustomTab
                        key={item.key}
                        id={item.key}
                        title={t(item.translation)}
                        icon={item?.icon}
                        selected={selectedTab === item.key}
                        onClick={() => {
                            setSelectedTab(item.key)
                        }}
                    />
                ))}
            </CustomTabContainer>

            <div className="flex-grow-1 min-h-0 d-flex flex-column">
                {isHouseholdMembers ? (
                    <MyHouseholdMembersCards
                        buildingDetail={buildingDetail}
                        onCreateMember={() => setCreateMemberModal(true)}
                        modified={modified}
                        setModified={setModified}
                    />
                ) : (
                    <MyApartmentInvitationsTable
                        buildingDetail={buildingDetail}
                        onInvite={() => setInviteExternalUserModal(true)}
                        modified={modified}
                        setModified={setModified}
                    />
                )}
            </div>

            {createMemberModal &&
                <CreateHouseholdMemberModal
                    show={createMemberModal}
                    onHide={() => setCreateMemberModal(false)}
                    setModified={setModified}
                    buildingDetail={buildingDetail}
                />
            }

            {inviteExternalUserModal &&
                <InviteExternalUserModal
                    show={inviteExternalUserModal}
                    onHide={() => setInviteExternalUserModal(false)}
                    buildingDetail={buildingDetail}
                    setModified={setModified}
                />
            }

        </div>
    );

}

export default MyApartmentDetailsMainTabs
